module.exports = __webpack_public_path__ + "static/media/left_girl_img.ec10b520.png";